// extracted by mini-css-extract-plugin
export var subtitle = "index-module--subtitle--1_Ie0";
export var list = "index-module--list--2rsfE";
export var iconSize = "index-module--iconSize--2T4JR";